import CampaignTypes from './campaign-types';

export default CampaignTypes;